// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"b013a6d4","242":"b013a6d4"}[chunkId] + ".chunk.css";
};